import { render, staticRenderFns } from "./Tippy.vue?vue&type=template&id=19d9c0e8"
import script from "./Tippy.vue?vue&type=script&lang=js"
export * from "./Tippy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports